import React, { useCallback } from 'react';

import './ParticipantSelect.scss';
import { apiInstance, ParticipantInfo } from '@api';
import { ChipsSelect } from '@components';

interface ParticipantSelectProps {
	onChange?: (values: ParticipantInfo[]) => void,
	values: ParticipantInfo[],
	suggestedValues: ParticipantInfo[],
	name?: string,
	className?: string,
	disabled?: boolean,
	maxValues?: number,
}

function ParticipantSelect(props: ParticipantSelectProps): JSX.Element {
	const {
		className,
		disabled,
		onChange,
		values,
		name,
		suggestedValues,
		maxValues,
	} = props;

	const onProcessQuery = useCallback((query: string, maxResults: number) => {
		return apiInstance.queryParticipant(query, maxResults);
	}, []);

	return <ChipsSelect
				className={className}
				disabled={disabled}
				onChange={onChange}
				values={values}
				suggestedValues={suggestedValues}
				name={name}
				processQuery={onProcessQuery} 
				queryHint="Начните ввод для поиска сотрудников"
				maxValues={maxValues}
			/>;
}

const MemoisedParticipantSelect = React.memo(ParticipantSelect);

export {MemoisedParticipantSelect as ParticipantSelect};